// Synexis (redesign, handoff B1b): input de código OTP em 6 caixas.
// 6 inputs de 1 dígito sincronizados num hidden `one_time_code` (contrato do backend,
// que já ignora não-dígitos). Auto-avanço, backspace volta, colar distribui os dígitos
// e o submit do formulário fica desabilitado até completar os 6.
export default class extends HTMLElement {
  connectedCallback () {
    this.boxes = [...this.querySelectorAll('[data-target="otp-input.box"]')]
    // NAO usar `this.hidden`: e propriedade padrao de HTMLElement (booleana, reflete o
    // atributo `hidden`), entao a atribuicao esconderia o elemento e a leitura devolveria true.
    this.hiddenInput = this.querySelector('[data-target="otp-input.value"]')

    this.boxes.forEach((box, index) => {
      box.addEventListener('input', () => this.onInput(index))
      box.addEventListener('keydown', (e) => this.onKeydown(e, index))
      box.addEventListener('paste', (e) => this.onPaste(e))
      box.addEventListener('focus', () => box.select())
    })

    this.sync()
    // Re-sync assincrono (round 1 da Onda 8.2) — defesa em profundidade, e o cabecalho
    // nao promete mais que isso: HOJE nenhum caminho alcanca o cenario que ele cobre,
    // porque form.js nao importa Turbo (medido) e todo load das paginas de OTP e full
    // load, onde a ordem de REGISTRO (toggle-submit antes, otp-input por ultimo, em
    // form.js E application.js) garante que este sync roda depois do enable incondicional
    // do toggle_submit.js:3. Essa ordem e o que os specs de "botao desabilitado com 0
    // digitos" guardam de verdade. O setTimeout so importa se um dia um <otp-input>
    // aparecer numa pagina do pack application (que TEM Turbo): num body-swap os
    // elementos conectam em ordem de DOCUMENTO e o toggle re-habilitaria por cima do
    // gate. Nao ha spec que prove este ramo — declarado, nao provado.
    setTimeout(() => this.sync(), 0)
  }

  onInput (index) {
    const box = this.boxes[index]
    const digits = box.value.replace(/\D/g, '')

    // Autofill de one-time-code costuma inserir os 6 digitos de uma vez no primeiro
    // campo (evento input, nao paste) — distribui como no colar.
    if (digits.length > 1) {
      this.fill(digits)

      return
    }

    box.value = digits

    if (box.value && index < this.boxes.length - 1) this.boxes[index + 1].focus()

    this.sync()
  }

  onKeydown (e, index) {
    if (e.key === 'Backspace' && !this.boxes[index].value && index > 0) {
      e.preventDefault()

      this.boxes[index - 1].focus()
      this.boxes[index - 1].value = ''

      this.sync()
    }
  }

  onPaste (e) {
    e.preventDefault()

    const digits = (e.clipboardData?.getData('text') || '').replace(/\D/g, '')

    if (!digits) return

    this.fill(digits)
  }

  fill (digits) {
    const sliced = digits.slice(0, this.boxes.length)

    this.boxes.forEach((box, i) => { box.value = sliced[i] || '' })
    this.boxes[Math.min(sliced.length, this.boxes.length - 1)].focus()

    this.sync()
  }

  sync () {
    const code = this.boxes.map((b) => b.value).join('')

    this.hiddenInput.value = code

    this.boxes.forEach((box) => box.classList.toggle('otp-box-filled', !!box.value))

    // Desabilita o botao de CONFIRMAR do formulario do codigo — nunca o de reenviar,
    // que fica dentro do mesmo form mas aponta para outro via atributo form=.
    const form = this.closest('form')
    const submit = form && [...form.querySelectorAll('button[type="submit"], input[type="submit"]')]
      .find((el) => !el.getAttribute('form') || el.getAttribute('form') === form.id)

    if (submit) submit.disabled = code.length !== this.boxes.length
  }
}
